import { makeStyles } from '@material-ui/core'

export const indexStyles = makeStyles(theme => ({
  root: {},
}))
